export const ATENDIMENTO_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://everest.ind.br/pt#organization",
   "name": "Everest Refrigeração Indústria e Comércio",
   "url": "https://everest.ind.br/pt",
   "logo": {
    "@type": "ImageObject",
    "url": "https://everest.ind.br/assets/images/logo-slogan.png",
    "contentUrl": "https://everest.ind.br/assets/images/logo-slogan.png"
   }
  },
  {
   "@type": "WebSite",
   "@id": "https://everest.ind.br/pt#website",
   "url": "https://everest.ind.br/pt",
   "name": "Everest | Purificadores e Máquinas de Gelo",
   "publisher": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "inLanguage": "pt-BR",
   "potentialAction": {
    "@type": "SearchAction",
    "target": "https://everest.ind.br/pt?s={search_term_string}",
    "query-input": "required name=search_term_string"
   }
  },
  {
   "@type": "ContactPage",
   "@id": "https://everest.ind.br/pt/atendimento#webpage",
   "url": "https://everest.ind.br/pt/atendimento",
   "name": "Atendimento ao Cliente | Everest",
   "description": "Entre em contato com a Everest: suporte técnico, dúvidas sobre purificadores, máquinas de gelo e atendimento pós-venda.",
   "inLanguage": "pt-BR",
   "isPartOf": {
    "@id": "https://everest.ind.br/pt#website"
   },
   "about": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "breadcrumb": {
    "@id": "https://everest.ind.br/pt/atendimento#breadcrumb"
   },
   "primaryImageOfPage": {
    "@type": "ImageObject",
    "url": "https://everest.ind.br/assets/images/atendimento.jpg"
   }
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/atendimento#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/pt"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Atendimento",
     "item": "https://everest.ind.br/pt/atendimento"
    }
   ]
  }
 ]
}
